import { ExternalTaxRatesInterface } from 'client/Interfaces/ExternalVATRatesInterface'

import * as api from '../api/accounting'
import { ExternalBillyActions } from './actionTypes'
import { actionCreatorAsync } from './index'

export function getExternalVATRates() {
  return actionCreatorAsync<ExternalTaxRatesInterface>(ExternalBillyActions.GET_EXTERNAL_TAX_RATES, async () =>
    api.getExternalVATRates(),
  )
}
